import { environment } from '../../../environments/environment';

type FluxtailRuntimeConfig = {
  matomoSiteId?: string;
  matomoUrl?: string;
};

export type MatomoQueueEntry = [string, ...unknown[]];
export type MatomoQueue = MatomoQueueEntry[];

declare global {
  interface Window {
    __FLUXTAIL_RUNTIME_CONFIG__?: FluxtailRuntimeConfig;
    _paq?: MatomoQueue;
  }
}

const normalizeValue = (value?: string | null): string => value?.trim() ?? '';

export const getMatomoConfig = (): { matomoSiteId: string; matomoUrl: string } | null => {
  const runtimeConfig =
    typeof window !== 'undefined' ? window.__FLUXTAIL_RUNTIME_CONFIG__ ?? {} : {};

  const matomoUrl = normalizeValue(runtimeConfig.matomoUrl) || normalizeValue(environment.matomoUrl);
  const matomoSiteId =
    normalizeValue(runtimeConfig.matomoSiteId) || normalizeValue(environment.matomoSiteId);

  if (!matomoUrl || !matomoSiteId) {
    return null;
  }

  return {
    matomoUrl: matomoUrl.replace(/\/+$/, ''),
    matomoSiteId,
  };
};
